<p-toast position="bottom-center">
  <ng-template #message let-msg>
    <span class="p-toast-message-icon" aria-hidden="true">
      <i [class]="getIconClass(msg)"></i>
    </span>
    <div
      class="p-toast-message-text"
      [style.cursor]="msg.data?.commands ? 'pointer' : 'default'"
      (click)="onToastClick(msg)"
    >
      <div class="p-toast-summary">{{ msg.summary }}</div>
      <div class="p-toast-detail">{{ msg.detail }}</div>
    </div>
  </ng-template>
</p-toast>

